<template>
  <div class="cart-button-container">
    <router-link 
      to="/cart" 
      class="cart-button"
    >
      <div class="cart-icon-container">
        <i class="fas fa-shopping-cart cart-icon"></i>
        <span v-if="cartItemCount > 0" class="cart-badge">{{ cartItemCount }}</span>
      </div>
      <span class="cart-text">{{ $t('footer.cart') }}</span>
    </router-link>
  </div>
</template>

<script setup>
import { ref } from 'vue';

// Simulated cart items count (replace with actual cart logic)
const cartItemCount = ref(0);
</script>

<style scoped>
.cart-button-container {
  position: fixed;
  bottom: 75px;
  right: 27px;
  z-index: 1001;
}

.cart-button {
  display: flex;
  align-items: center;
  background-color: #1268B1; /* Cyan's primary blue */
  color: white;
  text-decoration: none;
  padding: 10px 15px;
  border-radius: 30px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  position: relative;
}

.cart-button:hover {
  background-color: #0d4f8c;
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
}

.cart-icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  position: relative;
}

.cart-icon {
  font-size: 24px;
}

.cart-badge {
  position: absolute;
  top: -8px;
  right: -8px;
  background-color: #ff0000;
  color: white;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
}

.cart-text {
  font-weight: 600;
  font-size: 16px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .cart-button-container {
    bottom: 65px;
    right: 20px;
  }

  .cart-button {
    padding: 8px 12px;
  }

  .cart-icon {
    font-size: 20px;
  }

  .cart-text {
    font-size: 14px;
  }

  .cart-badge {
    width: 16px;
    height: 16px;
    font-size: 10px;
  }
}

/* RTL Support */
[dir="rtl"] .cart-icon-container {
  margin-right: 0;
  margin-left: 10px;
}
</style>